import ApproveClaimExtendDialog from "./approveClaimExtendDialog.container";

export default ApproveClaimExtendDialog;
